function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.75 14.2809L10.5 17.2339L5.25 14.2809V11.1609L3.75 10.3279V15.1589L10.5 18.9559L17.25 15.1589V10.3279L15.75 11.1609V14.2809Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 0L0 5.444V6.744L10.5 12.577L19.5 7.577V11.719H21V5.444L10.5 0ZM18 6.695L10.5 10.862L1.96 6.118L10.5 1.69L19.04 6.118L18 6.695Z"
});

var SvgYearIcon = function SvgYearIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    fill: "none",
    viewBox: "0 0 21 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYearIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/year-icon.6e477d93.svg";
export { ForwardRef as ReactComponent };